import styled, { keyframes, createGlobalStyle } from 'styled-components'

export const PageContainer = styled.main`
  min-height: 100vh;
  background: #fff;
  display: flex;
  flex-direction: column;
`

export const Inner = styled.div`
  flex: 1;
  max-width: 900px;
  margin: 0 auto;
  background: #fff;
  padding: 16px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  gap: 16px;
  flex-wrap: wrap;
  flex-shrink: 0;
`

export const SearchInput = styled.input`
  flex: 1;
  min-width: 200px;
  max-width: 400px;
  padding: 12px 16px;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  font-size: 14px;
  color: #1F2937;
  background: #fff;
  transition: all 0.2s ease;
  
  &::placeholder {
    color: #9CA3AF;
  }
  
  &:focus {
    outline: none;
    border-color: #0047BB;
    box-shadow: 0 0 0 3px rgba(0, 71, 187, 0.1);
  }
`

export const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;
`

export const AddBtn = styled.button`
  background: linear-gradient(135deg, #0047BB 0%, #0056d6 100%);
  color: #fff;
  border: none;
  padding: 12px 24px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 71, 187, 0.3);
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
  &:hover { transform: translateY(-2px); box-shadow: 0 6px 20px rgba(0,71,187,0.4); }
`

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
  overflow-y: auto;
  padding-right: 4px;
  
  /* Custom scrollbar */
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #a1a1a1;
  }
`

const slideIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const Card = styled.div<{ index: number }>`
  background: #fff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #f0f0f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  min-height: 80px;
  animation: ${slideIn} 0.3s ease-out forwards;
  animation-delay: ${({ index }) => `${Math.min(index, 5) * 0.1}s`};
  &:hover { box-shadow: 0 8px 25px rgba(0,0,0,0.15); transform: translateY(-2px); }
  &::before { content:''; position:absolute; top:0; left:0; width:4px; height:100%; background: linear-gradient(135deg, #0047BB 0%, #0056d6 100%); opacity: 0; transition: opacity 0.3s ease; }
  &:hover::before { opacity: 1; }
`

export const Info = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
  margin-right: 20px;
`

export const Pin = styled.div`
  width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; color: #0047BB; font-size: 24px;
`

export const Details = styled.div`
  flex: 1;
`

export const Address = styled.div`
  font-size: 18px; font-weight: 600; color: #1a1a1a; margin-bottom: 4px; letter-spacing: -0.5px;
`

export const Meta = styled.div`
  font-size: 14px; color: #666; display: flex; align-items: center; gap: 16px;
`

// Mobile-specific name/address rows (hidden on desktop by default)
/* NameRow/PracticeName/SubAddress removed from layout; reverting to single-line headline */

export const Badge = styled.span<{ variant: 'active' | 'failed' | 'cancelled' | 'none' }>`
  font-weight: 500; padding: 4px 8px; border-radius: 6px; font-size: 12px; text-transform: uppercase; letter-spacing: .5px;
  ${({ variant }) => variant === 'active' && `color:#28a745;background:rgba(40,167,69,.1);`}
  ${({ variant }) => variant === 'failed' && `color:#dc3545;background:rgba(220,53,69,.1);`}
  ${({ variant }) => variant === 'cancelled' && `color:#fd7e14;background:rgba(253,126,20,.1);`}
  ${({ variant }) => variant === 'none' && `color:#666;background:#f2f2f2;`}
`

export const Actions = styled.div`
  display: flex; align-items: center; gap: 12px;
`

export const ViewBtn = styled.button`
  background: linear-gradient(135deg, #0047BB 0%, #0056d6 100%);
  color: #fff; border: none; padding: 10px 20px; border-radius: 8px; font-size: 14px; font-weight: 600; cursor: pointer; transition: all .2s ease; display:flex; align-items:center; gap:6px;
  &:hover { background: linear-gradient(135deg, #0056d6 0%, #0047BB 100%); transform: translateX(2px); }
`

export const DeleteBtn = styled.button`
  background: none; border: none; color: #dc3545; font-size: 18px; cursor: pointer; padding: 8px; border-radius: 8px; transition: all .2s ease; opacity: .7;
  &:hover { background: rgba(220, 53, 69, .1); opacity: 1; transform: scale(1.1); }
`

export const EmptyState = styled.div`
  text-align: center; padding: 60px 20px; color: #666;
`

export const EmptyIcon = styled.div`
  font-size: 48px; margin-bottom: 16px; opacity: .5;
`

export const EmptyTitle = styled.div`
  font-size: 20px; font-weight: 600; margin-bottom: 8px; color: #1a1a1a;
`

export const EmptySubtitle = styled.div`
  font-size: 16px; margin-bottom: 24px;
`
export const Responsive = createGlobalStyle`
  /* Tablet tweaks */
  @media (max-width: 1024px) {
    ${Inner} { padding: 16px 12px; }
    ${Card} { padding: 20px; }
  }

  @media (max-width: 768px) {
    ${Header} { flex-direction: column; align-items: stretch; gap: 12px; margin-bottom: 16px; }
    ${SearchInput} { max-width: none; }
    ${HeaderRight} { justify-content: flex-end; }
    ${AddBtn} { width: auto; align-self: flex-end; }
    ${List} { gap: 12px; }
    ${Card} { padding: 18px 14px; border-radius: 12px; flex-direction: column; align-items: stretch; gap: 14px; }
    ${Info} { flex-direction: column; align-items: center; text-align: center; gap: 8px; }
    ${Address} { font-size: 16px; }
    ${Meta} { flex-direction: column; gap: 6px; align-items: center; font-size: 13px; }
    ${Actions} { justify-content: center; padding-top: 16px; border-top: 1px solid #f0f0f0; }
    ${ViewBtn} { width: 100%; justify-content: center; padding: 12px 20px; }
    ${Info} > ${Pin} { display: inline-flex; margin-right: 0; }
  }

  @media (max-width: 480px) {
    ${Card} { padding: 14px 12px; border-radius: 12px; }
    ${AddBtn} { padding: 10px 18px; font-size: 14px; }
    ${Address} { font-size: 15px; }
  }
`
